import React from 'react'

import { ActivityIndicator, Button, Icon } from '@fourthwall/components'
import { FilterIcon } from '@fourthwall/icons'

import * as S from './AnalyticsFiltersButton.styled'

type AnalyticsFiltersButtonProps = {
  isActive?: boolean
  onClick: () => void
}

export const AnalyticsFiltersButton = ({ isActive, onClick }: AnalyticsFiltersButtonProps) => {
  return (
    <S.Container>
      <Button
        leftIcon={<Icon component={FilterIcon} height={18} />}
        label="Filters"
        appearance="secondary"
        size="small"
        onClick={onClick}
      />
      {isActive && (
        <S.ActivityIndicatorWrapper>
          <ActivityIndicator />
        </S.ActivityIndicatorWrapper>
      )}
    </S.Container>
  )
}
